module.exports = __webpack_public_path__ + "static/img/wechatNew.86ca70ca.png";